<div class="chart-title">{{ chartTitle }}</div>
<div class="chart-container">
  <canvas id="doughnutChart">{{ doughnutChart }}</canvas>
</div>
<div><app-legends-color [legendCollection]="chartLegends"></app-legends-color></div>